import React from 'react';
import "./docs-panel.css";
import Link from '../../shared/link';
import { t, getCurrentLanguage } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class DocsPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        const { currentLanguage } = this.state;
        
        return (
            <div className="docs-panel">
                <div className="docs-panel-title-group">
                    <h4 className="docs-panel-product-name">{t('linha_protheus', currentLanguage)}</h4>
                    <h1 className="docs-panel-title">{t('documentacao_produto', currentLanguage)}</h1>
                </div>
                <div className="docs-panel-content">
                    <Link text={t('melhorias', currentLanguage)} link="https://tdn.totvs.com/pages/viewpage.action?pageId=874600375" />
                    <Link text={t('legislacao', currentLanguage)} link="https://tdn.totvs.com/pages/viewpage.action?pageId=874600401" />
                    <Link text={t('manutencao', currentLanguage)} link="https://tdn.totvs.com/pages/viewpage.action?pageId=874600501" />
                </div>
            </div>
        );
    }
};

export default DocsPanel;